import React, { useState } from "react";

import ServiceApi from "../services/service.api";
import ContextApp from "../contexts/context.app";
// import BasketStorage from "../../ui/views/Basket/Component/BasketStorage";
import ServiceStorage from "../services/service.storage";

function ProviderApp({ children }) {

  const [isAuth, setIsAuthState] = useState(ServiceApi.hasToken());
  // const [userInfo, setUserInfo] = useState(ServiceStorage.getUserInfo());//{name:"",phone:""}
  // const [basketInfo, setbasketInfo] = useState(BasketStorage.getBasket());
  // const [basketPersonInfo, setbasketPersonInfo] = useState(BasketStorage.getBasketPerson());
  // const [lastUpdate, setLastUpdate] = useState();

  const setIsAuth = (value) => {
    if (value) {
      ServiceApi.setToken();
    } else {
      ServiceApi.logout();
    }
    setIsAuthState(value);
  };

  const ctxApp = {
    isAuth,
    setIsAuth,
    // userInfo,
    // setUserInfo,
    // basketInfo,
    // setbasketInfo,
    // basketPersonInfo,
    // setbasketPersonInfo,
    // lastUpdate,
    // setLastUpdate
  };

  return <ContextApp.Provider value={ctxApp}>{children}</ContextApp.Provider>;
}

export default ProviderApp;
